import CancelablePromise from 'cancelable-promise';
import { ApiResult } from '../types/ApiResult';
import { CustomAppointmentType } from '../types/CustomAppointmentType';
import apiClient from './appApi';

export default function getCustomAppointmentTypes(/*params: {}*/): CancelablePromise<ApiResult<CustomAppointmentType[]>> {
  return apiClient.post<ApiResult<CustomAppointmentType[]>, {}>(
    '/CMSPages/SonovaBookAppointment/GetCustomAppointmentTypes.ashx',
    {} /*params,*/,
  );
}
